
import type {LoginFormData} from '../services/types';
// import FirebaseService from '../services/FirebaseService';
import Vue from 'vue';

type Data = {
  showPassword: boolean;
  errormessage: string;
} & LoginFormData;

export default Vue.extend({
  name: 'login-user',
  data: (): Data => ({
    email: '',
    password: '',
    showPassword: false,
    errormessage: '',
  }),
  computed: {
    passwordType() {
      return this.showPassword ? 'text' : 'password';
    },
    passwordIcon() {
      return this.showPassword ? 'mdi-eye' : 'mdi-eye-off';
    },
  },
  watch: {},
  methods: {
    async auth() {
      try {
        await this.$store.dispatch('login', {
          email: this.email,
          password: this.password,
        });
      } catch (e) {
        console.log(e);
        this.errormessage = 'メールアドレスもしくはパスワードが違います';
        if (e instanceof Error && e.message) {
          this.errormessage += `: ${e.message}`;
        }
      }
    },
    passwordToggle() {
      this.showPassword = !this.showPassword;
    },
  },
});
